import React, { useEffect, useState } from "react";
import { BsFillQuestionCircleFill, BsUpload } from "react-icons/bs";
import { IoIosArrowRoundBack } from "react-icons/io";
import RoomImage from "../../../../helper/images/roomimage.png";
import { RiImageAddFill } from "react-icons/ri";
import { FiTrash } from "react-icons/fi";
import RoomImage1 from "../../../../helper/images/Roomimgage1.png";
import Roomimage2 from "../../../../helper/images/RoomImage2.png";
import {
  addRoom,
  getAllHotels,
  updateRoom,
} from "../../../../api/owner/hotels/rooms";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "../../../../hooks/useTranslation";

const AddNewRoom = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [id, setId] = useState("");

  // Reservation Status options with translations
  const reservationStatusOptions = [
    { value: "Vacant", label: t("addNewRoom").statusOptions.vacant },
    { value: "Available", label: t("addNewRoom").statusOptions.available },
    { value: "Reserved", label: t("addNewRoom").statusOptions.reserved },
    { value: "Occupied", label: t("addNewRoom").statusOptions.occupied },
    { value: "Checked-in", label: t("addNewRoom").statusOptions.checkedIn },
    { value: "Checked-out", label: t("addNewRoom").statusOptions.checkedOut },
    { value: "Cancelled", label: t("addNewRoom").statusOptions.cancelled },
    { value: "No-show", label: t("addNewRoom").statusOptions.noShow },
    { value: "Pending", label: t("addNewRoom").statusOptions.pending },
    { value: "Confirmed", label: t("addNewRoom").statusOptions.confirmed },
    { value: "Unavailable", label: t("addNewRoom").statusOptions.unavailable }
  ];

  // Room Type options
  const roomTypeOptions = [
    { value: "Standard", label: t("addNewRoom").roomTypeOptions.standard },
    { value: "Deluxe", label: t("addNewRoom").roomTypeOptions.deluxe },
    { value: "Suite", label: t("addNewRoom").roomTypeOptions.suite },
    { value: "Family", label: t("addNewRoom").roomTypeOptions.family },
    { value: "Executive", label: t("addNewRoom").roomTypeOptions.executive },
    { value: "Presidential", label: t("addNewRoom").roomTypeOptions.presidential }
  ];

  // Bed Type options
  const bedTypeOptions = [
    { value: "Single", label: t("addNewRoom").bedTypeOptions.single },
    { value: "Double", label: t("addNewRoom").bedTypeOptions.double },
    { value: "Twin", label: t("addNewRoom").bedTypeOptions.twin },
    { value: "Full", label: t("addNewRoom").bedTypeOptions.full },
    { value: "Queen", label: t("addNewRoom").bedTypeOptions.queen },
    { value: "King", label: t("addNewRoom").bedTypeOptions.king },
    { value: "Sofa Bed", label: t("addNewRoom").bedTypeOptions.sofaBed },
    { value: "Bunk Bed", label: t("addNewRoom").bedTypeOptions.bunkBed },
    { value: "Murphy Bed", label: t("addNewRoom").bedTypeOptions.murphyBed },
    { value: "Rollaway Bed", label: t("addNewRoom").bedTypeOptions.rollawayBed },
    { value: "Daybed", label: t("addNewRoom").bedTypeOptions.daybed },
    { value: "Crib", label: t("addNewRoom").bedTypeOptions.crib }
  ];
  const [formData, setFormData] = useState({
    roomNumber: "",
    roomFloor: "",
    roomType: "",
    roomCapacity: "",
    price: "",
    reservationStatus: "",
    bedType: "",
    roomSize: "",
    description: "",
    facilities: [],
    accessibility: [],
    hotelId: "",
    images: [],
  });
  const [errors, setErrors] = useState({
    roomNumber: "",
    roomFloor: "",
    roomType: "",
    roomCapacity: "",
    reservationStatus: "",
    price: "",
    bedType: "",
    roomSize: "",
    description: "",
    facilities: [],
    accessibility: [],
    hotelId: "",
    images: "",
  });
  const location = useLocation();
  const isEditing = location.state?.isEditing;
  const roomData = location.state?.roomData;
  const navigate = useNavigate();
  const [existingImages, setExistingImages] = useState([]);

  useEffect(() => {
    if (isEditing && roomData) {
      setId(roomData._id);
      setFormData({
        roomNumber: roomData.roomNumber || "",
        roomFloor: roomData.roomFloor || "",
        roomType: roomData.roomType || "",
        roomCapacity: roomData.roomCapacity?.toString() || "",
        price: roomData.price?.toString() || "",
        reservationStatus: roomData.reservationStatus || "",
        bedType: roomData.bedType || "",
        roomSize: roomData.roomSize || "",
        description: roomData.description || "",
        facilities: roomData.facilities || [],
        accessibility: roomData.accessibility || [],
        hotelId: roomData.hotelId || "",
      });
      setExistingImages(roomData.images || []);
    }
  }, [isEditing, roomData]);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["hotels-listing"],
    queryFn: getAllHotels,
    keepPreviousData: true,
  });

  const hotels = data?.data?.hotels || [];

  const { mutate: addRoomMutation , isPending : isAdding} = useMutation({
    mutationFn: addRoom,
    onSuccess: () => {
      queryClient.invalidateQueries(["rooms"]);
      toast.success(t("addNewRoom").toastMessages.addSuccess);
      setFormData({
        roomNumber: "",
        roomFloor: "",
        roomType: "",
        roomCapacity: "",
        price: "",
        reservationStatus: "",
        bedType: "",
        roomSize: "",
        description: "",
        facilities: [],
        accessibility: [],
        hotelId: "",
        images: [],
      });
      navigate("/roomlisting");
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        t("addNewRoom").toastMessages.addError;
      toast.error(errorMessage);
    },
  });

  const { mutate: updateRoomMutation , isPending : isUpdating } = useMutation({
    mutationFn: (data) => updateRoom(roomData._id, data),
    enabled: isEditing,
    onSuccess: () => {
      queryClient.invalidateQueries(["rooms"]);
      toast.success(t("addNewRoom").toastMessages.updateSuccess);
      navigate("/roomlisting");
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message ||
        t("addNewRoom").toastMessages.updateError;
      toast.error(errorMessage);
    },
  });

  const toggleOption = (field, label) => {
    setFormData((prevData) => {
      const updatedField = prevData[field].includes(label)
        ? prevData[field].filter((item) => item !== label)
        : [...prevData[field], label];

      return { ...prevData, [field]: updatedField };
    });
  };

  const amenities = [
    t("addNewRoom").amenities[0],
    t("addNewRoom").amenities[1],
    t("addNewRoom").amenities[2],
    t("addNewRoom").amenities[3],
    t("addNewRoom").amenities[4],
    t("addNewRoom").amenities[5],
    t("addNewRoom").amenities[6],
    t("addNewRoom").amenities[7],
    t("addNewRoom").amenities[8],
    t("addNewRoom").amenities[9],
    t("addNewRoom").amenities[10],
    t("addNewRoom").amenities[11],
  ];

  const Accessibility = [
    t("addNewRoom").accessibility[0],
    t("addNewRoom").accessibility[1],
    t("addNewRoom").accessibility[2],
  ];

  const validateForm = (data) => {
    const newErrors = {};
    if (!data.roomNumber)
      newErrors.roomNumber = t("addNewRoom").validation.roomNumber;
    if (!data.roomFloor)
      newErrors.roomFloor = t("addNewRoom").validation.roomFloor;
    if (!data.roomType)
      newErrors.roomType = t("addNewRoom").validation.roomType;
    if (!data.roomCapacity)
      newErrors.roomCapacity = t("addNewRoom").validation.roomCapacity;
    if (!data.reservationStatus)
      newErrors.reservationStatus =
        t("addNewRoom").validation.reservationStatus;
    if (!data.price) newErrors.price = t("addNewRoom").validation.price;
    else if (isNaN(data.price))
      newErrors.price = t("addNewRoom").validation.priceNumber;
    if (!data.bedType) newErrors.bedType = t("addNewRoom").validation.bedType;
    if (!data.roomSize)
      newErrors.roomSize = t("addNewRoom").validation.roomSize;
    if (!data.description)
      newErrors.description = t("addNewRoom").validation.description;
    if (!data.facilities || data.facilities.length === 0) {
      newErrors.facilities = t("addNewRoom").validation.facilities;
    }
    if (!data.accessibility || data.accessibility.length === 0) {
      newErrors.accessibility = t("addNewRoom").validation.accessibility;
    }

    return newErrors;
  };

  const validateField = (name, value) => {
    switch (name) {
      case "roomNumber":
        return value ? "" : t("addNewRoom").validation.roomNumber;
      case "roomFloor":
        return value ? "" : t("addNewRoom").validation.roomFloor;
      case "roomType":
        return value ? "" : t("addNewRoom").validation.roomType;
      case "roomCapacity":
        return value ? "" : t("addNewRoom").validation.roomCapacity;
      case "price":
        if (!value) return t("addNewRoom").validation.price;
        if (isNaN(value)) return t("addNewRoom").validation.priceNumber;
        return "";
      case "bedType":
        return value ? "" : t("addNewRoom").validation.bedType;
      case "roomSize":
        return value ? "" : t("addNewRoom").validation.roomSize;
      case "description":
        return value ? "" : t("addNewRoom").validation.description;
      case "facilities":
        return value && value.length > 0
          ? ""
          : t("addNewRoom").validation.facilities;
      case "accessibility":
        return value && value.length > 0
          ? ""
          : t("addNewRoom").validation.accessibility;
      case "hotelId":
        return value ? "" : t("addNewRoom").validation.hotelId;
      default:
        return "";
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "images") {
      const selectedFiles = Array.from(files);
      
      // Validate file types - only allow JPG, PNG, and JPEG
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      const invalidFiles = selectedFiles.filter(file => !allowedTypes.includes(file.type.toLowerCase()));
      
      if (invalidFiles.length > 0) {
        const invalidFileNames = invalidFiles.map(f => f.name).join(', ');
        const errorMessage = t("addNewRoom").validation.invalidImageFormat.replace("{files}", invalidFileNames);
        toast.error(errorMessage);
        setErrors((prev) => ({ ...prev, images: t("addNewRoom").validation.imageFormatOnly }));
        
        // Reset file input
        e.target.value = '';
        return;
      }

      // Clear error if all files are valid
      const validFiles = selectedFiles.slice(0, 10);
      setFormData((prev) => ({ ...prev, images: validFiles }));
      setErrors((prev) => ({ ...prev, images: "" }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));

      const fieldError = validateField(name, value);
      setErrors((prev) => ({ ...prev, [name]: fieldError }));
    }
  };

  const handleDeleteImage = (index) => {
    setFormData((prev) => {
      const newImages = prev.images.filter((_, i) => i !== index);
      return { ...prev, images: newImages };
    });
  };

  const handleDeleteExistingImage = (index) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    const data = {
      roomNumber: formData.roomNumber,
      roomFloor: formData.roomFloor,
      roomType: formData.roomType,
      reservationStatus: formData.reservationStatus,
      roomCapacity: formData.roomCapacity,
      price: parseFloat(formData.price),
      bedType: formData.bedType,
      roomSize: formData.roomSize,
      description: formData.description,

      hotelId: formData.hotelId,
    };

    const form = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      form.append(key, value);
    });

    if (!formData.hotelId) {
      toast.error(t("addNewRoom").validation.hotelId);
      return;
    }

    if (!isEditing && formData.images.length === 0) {
      toast.error(t("addNewRoom").validation.images);
      return;
    }

    formData.facilities.forEach((facility) => {
      form.append("facilities", facility);
    });

    formData.accessibility.forEach((item) => {
      form.append("accessibility", item);
    });

    if (formData.images && formData.images.length > 0) {
      formData.images.forEach((file) => {
        form.append("images", file);
      });
    }

    if (isEditing) {
      updateRoomMutation(form);
    } else {
      addRoomMutation(form);
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: t("addNewRoom").deleteConfirm.title,
      text: t("addNewRoom").deleteConfirm.text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("addNewRoom").deleteConfirm.confirm,
      cancelButtonText: t("addNewRoom").deleteConfirm.cancel,
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData({
          roomNumber: "",
          roomFloor: "",
          roomType: "",
          roomCapacity: "",
          price: "",
          reservationStatus: "",
          bedType: "",
          roomSize: "",
          description: "",
          facilities: [],
          accessibility: [],
          hotelId: "",
          images: [],
        });
        setErrors({});
      }
    });
  };

  return (
    <>
      <div className="flex gap-[10px] items-center">
        <div className="w-[32px] h-[32px] bg-[#4CAF50] rounded-[50%] flex items-center justify-center hover:bg-[#FF9D00]">
          <IoIosArrowRoundBack
            onClick={() => navigate(-1)}
            size={24}
            className="text-[#fff]"
          />
        </div>
        <h2 className="text-[22px] font-medium">
          {isEditing ? t("addNewRoom").title.edit : t("addNewRoom").title.add}
        </h2>
      </div>
      <div className="mt-[22px] py-[22px] lg:px-[30px] md:px-[20px] px-[15px] bg-white border border-[#DDDDDD] rounded-[16px] flex flex-col md:gap-[30px] gap-[15px]">
        <div className="flex gap-[10px] items-center">
          <h2 className="text-base font-medium text-black">
            {" "}
            {t("addNewRoom").sections.roomPicture}
          </h2>
          <span className="w-full max-w-[28px] h-[28px] flex items-center justify-center bg-[#F2F2F2] rounded-[50%]">
            <BsFillQuestionCircleFill size={16} className="text-[#404040]" />
          </span>
        </div>

        <div className="flex flex-wrap gap-[16px]">
          {/* Show existing images when editing */}
          {isEditing && existingImages && existingImages.length > 0 && (
            existingImages.map((img, idx) => (
              <div key={`existing-${idx}`} className="relative">
                <img
                  src={`${img}`}
                  alt={`Room image ${idx + 1}`}
                  className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px]"
                />
                <button
                  onClick={() => handleDeleteExistingImage(idx)}
                  className="absolute top-1 right-1 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 flex items-center justify-center shadow-md"
                  title="Delete image"
                  type="button"
                >
                  <FiTrash size={14} />
                </button>
              </div>
            ))
          )}
          
          {/* Show newly uploaded images */}
          {formData.images && formData.images.length > 0 && (
            formData.images.map((file, index) => (
              <div key={`new-${index}`} className="relative">
                <img
                  src={file instanceof File ? URL.createObjectURL(file) : file}
                  alt={`Room image ${index + 1}`}
                  className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px]"
                />
                <button
                  onClick={() => handleDeleteImage(index)}
                  className="absolute top-1 right-1 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 flex items-center justify-center shadow-md"
                  title="Delete image"
                  type="button"
                >
                  <FiTrash size={14} />
                </button>
              </div>
            ))
          )}
          
          {/* Fallback to static images if no images exist */}
          {((!isEditing && (!formData.images || formData.images.length === 0)) ||
            (isEditing && (!existingImages || existingImages.length === 0) && (!formData.images || formData.images.length === 0))) && (
            <>
              <img
                src={RoomImage}
                alt="Default Image 1"
                className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px]"
              />
              <img
                src={RoomImage1}
                alt="Default Image 2"
                className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px]"
              />
              <img
                src={Roomimage2}
                alt="Default Image 3"
                className="md:w-[200px] md:h-[120px] sm:w-[100px] sm:h-[100px] w-[50px] h-[50px] object-cover sm:rounded-[16px] rounded-[4px]"
              />
            </>
          )}

          <div className="bg-white p-5 border-dashed border-2 border-[#B9B9B9] rounded-[10px] text-center relative lg:w-[200px] lg:h-[120px] w-full h-[100px] flex flex-col items-center justify-center cursor-pointer">
            <input
              type="file"
              accept="image/jpeg,image/jpg,image/png"
              multiple
              className="opacity-0 absolute top-0 left-0 right-0 bottom-0 w-full h-full cursor-pointer"
              onChange={handleInputChange}
              name="images"
            />
            <RiImageAddFill
              size={24}
              className="text-[#8C8C8C] mx-auto block"
            />
            <p className="text-sm font-medium mt-[14px]">
              {t("addNewRoom").labels.addImage}
            </p>
          </div>
          {errors.images && (
            <p className="text-red-500 text-sm mt-1 col-span-full">{errors.images}</p>
          )}
        </div>

        <hr className="border-t border-[#DDDDDD] w-full" />
        <div className="grid grid-cols-1 sm:grid-cols-2">
          <div className="flex gap-[10px] items-center">
            <h2 className="text-base font-medium text-black">
              {t("addNewRoom").sections.roomDetails}
            </h2>
            <span className="w-full max-w-[28px] h-[28px] flex items-center justify-center bg-[#F2F2F2] rounded-[50%]">
              <BsFillQuestionCircleFill size={16} className="text-[#404040]" />
            </span>
          </div>
          <div class="relative ml-auto select-border flex">
            <select
              name="hotelId"
              className="appearance-none bg-[#FF9D00] text-white  p-[10px]  focus:outline-none focus:border-[#4CAF50] text-lg font-medium"
              value={formData.hotelId}
              onChange={handleInputChange}
            >
              <option value="" disabled selected>
                {t("addNewRoom").labels.selectHotel}
              </option>
              {hotels.map((hotel) => (
                <option key={hotel._id} value={hotel._id}>
                  {hotel.name}
                </option>
              ))}
            </select>

            <div class="pointer-events-none flex items-center pr-3 bg-[#FF9D00]">
              <svg
                class="h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-4 sm:grid-cols-2 md:gap-[30px_16px] gap-[15px]">
          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.roomNumber}
            </label>
            <input
              type="text"
              name="roomNumber"
              value={formData.roomNumber}
              onChange={handleInputChange}
              placeholder={t("addNewRoom").placeholders.roomNumber}
              className={`border rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.roomNumber ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            />
            {errors.roomNumber && (
              <p className="text-red-500 text-sm mt-1">{errors.roomNumber}</p>
            )}
          </div>

          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.roomFloor}
            </label>
            <input
              type="text"
              name="roomFloor"
              value={formData.roomFloor}
              onChange={handleInputChange}
              placeholder={t("addNewRoom").placeholders.roomFloor}
              className={`border rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.roomFloor ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            />
            {errors.roomFloor && (
              <p className="text-red-500 text-sm mt-1">{errors.roomFloor}</p>
            )}
          </div>
          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.reservationStatus}
            </label>

            <select
              name="reservationStatus"
              value={formData.reservationStatus}
              onChange={handleInputChange}
              className={`border rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.reservationStatus ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            >
              <option value="" disabled>
                {t("addNewRoom").placeholders.selectStatus}
              </option>
              {reservationStatusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.reservationStatus && (
              <p className="text-red-500 text-sm mt-1">
                {errors.reservationStatus}
              </p>
            )}
          </div>
          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.roomType}
            </label>
            <select
              name="roomType"
              value={formData.roomType}
              onChange={handleInputChange}
              className={`border rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.roomType ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            >
              <option value="" disabled>
                {t("addNewRoom").placeholders.selectRoomType}
              </option>
              {roomTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.roomType && (
              <p className="text-red-500 text-sm mt-1">{errors.roomType}</p>
            )}
          </div>

          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.roomCapacity}
            </label>

            <input
              type="number"
              name="roomCapacity"
              value={formData.roomCapacity}
              onChange={handleInputChange}
              placeholder={t("addNewRoom").placeholders.roomCapacity}
              className={`border rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.roomCapacity ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            />

            {errors.roomCapacity && (
              <p className="text-red-500 text-sm mt-1">{errors.roomCapacity}</p>
            )}
          </div>
          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.roomPrice}
            </label>

            <div class="relative rounded-md shadow-sm">
              <div class="pointer-events-none absolute top-[15px] left-0 flex items-center pl-3">
                <span class="text-[#8C8C8C] text-base">₾</span>
              </div>
              <input
                type="text"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                className={`border border-[#DDDDDD] rounded-[10px] p-[15px] pl-[32px] w-full focus:outline-none ${
                  errors.price ? "border-red-500" : "border-[#DDDDDD]"
                } focus:border-[#4CAF50]`}
                placeholder="price"
              />
              {errors.price && (
                <p className="text-red-500 text-sm mt-1">{errors.price}</p>
              )}
            </div>
          </div>
          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.bedType}
            </label>

            <select
              name="bedType"
              value={formData.bedType}
              onChange={handleInputChange}
              className={`border border-[#DDDDDD] rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.bedType ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            >
              <option value="" disabled>
                {t("addNewRoom").placeholders.selectBedType}
              </option>
              {bedTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors.bedType && (
              <p className="text-red-500 text-sm mt-1">{errors.bedType}</p>
            )}
          </div>
          <div>
            <label className="text-sm text-[#000000] mb-[8px] block">
              {t("addNewRoom").labels.roomSize}
            </label>
            <input
              type="text"
              name="roomSize"
              value={formData.roomSize}
              onChange={handleInputChange}
              placeholder={t("addNewRoom").placeholders.roomSize}
              className={`border border-[#DDDDDD] rounded-[10px] p-[15px] w-full focus:outline-none ${
                errors.roomSize ? "border-red-500" : "border-[#DDDDDD]"
              } focus:border-[#4CAF50]`}
            />
            {errors.roomSize && (
              <p className="text-red-500 text-sm mt-1">{errors.roomSize}</p>
            )}
          </div>
        </div>
        <div className="max-w-[545px]">
          <label className="text-sm text-[#000000] mb-[8px] block">
            {t("addNewRoom").labels.roomDescription}
          </label>
          <textarea
            type="text"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            placeholder={t("addNewRoom").placeholders.roomDescription}
            className={`border border-[#DDDDDD] rounded-[10px] p-[15px] w-full focus:outline-none ${
              errors.description ? "border-red-500" : "border-[#DDDDDD]"
            } focus:border-[#4CAF50]`}
          />
          {errors.description && (
            <p className="text-red-500 text-sm mt-1">{errors.description}</p>
          )}
        </div>

        <hr className="border-t border-[#DDDDDD] w-full" />

        <div className="flex gap-[10px] items-center">
          <h2 className="text-base font-medium text-black">
            {t("addNewRoom").sections.amenities}
          </h2>
          <span className="w-full max-w-[28px] h-[28px] flex items-center justify-center bg-[#F2F2F2] rounded-[50%]">
            <BsFillQuestionCircleFill size={16} className="text-[#404040]" />
          </span>
        </div>

        <div className="grid xl:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 md:gap-[30px_16px] gap-[15px]">
          {amenities.map((label) => {
            const isChecked = formData.facilities.includes(label);
            return (
              <label
                key={label}
                className="inline-flex items-center gap-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  className={`hidden ${isChecked ? "peer" : ""}`}
                  checked={isChecked}
                  onChange={() => toggleOption("facilities", label)}
                />
                <div className="border-2 border-[#6E7491] w-5 h-5 rounded-full peer-checked:marker:border-2 peer-checked:border-[#209b25] flex items-center justify-center peer-checked:bg-white">
                  <div
                    className={`w-2.5 h-2.5 rounded-full peer-checked:bg-[#209b25] ${
                      isChecked ? "bg-[#209b25]" : "bg-transparent"
                    }`}
                  />
                </div>
                <span className="text-black text-sm">{label}</span>
              </label>
            );
          })}

          {errors.facilities && (
            <p className="text-red-500 text-sm mt-1 col-span-full">
              {errors.facilities}
            </p>
          )}
        </div>
        <hr className="border-t border-[#DDDDDD] w-full" />

        <div className="flex gap-[10px] items-center">
          <h2 className="text-base font-medium text-black">
            {t("addNewRoom").sections.accessibilityFeatures}
          </h2>
          <span className="w-full max-w-[28px] h-[28px] flex items-center justify-center bg-[#F2F2F2] rounded-[50%]">
            <BsFillQuestionCircleFill size={16} className="text-[#404040]" />
          </span>
        </div>

        <div className="flex gap-[21px] flex-wrap">
          {Accessibility.map((label) => {
            const isChecked = formData.accessibility.includes(label);
            return (
              <label
                key={label}
                className="inline-flex items-center gap-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  className={`hidden ${isChecked ? "peer" : ""}`}
                  checked={isChecked}
                  onChange={() => toggleOption("accessibility", label)}
                />
                <div className="border-2 border-[#6E7491] w-5 h-5 rounded-full peer-checked:marker:border-2 peer-checked:border-[#209b25] flex items-center justify-center peer-checked:bg-white">
                  <div
                    className={`w-2.5 h-2.5 rounded-full peer-checked:bg-[#209b25] ${
                      isChecked ? "bg-[#209b25]" : "bg-transparent"
                    }`}
                  />
                </div>
                <span className="text-black text-sm">{label}</span>
              </label>
            );
          })}

          {errors.accessibility && (
            <p className="text-red-500 text-sm mt-1 col-span-full">
              {errors.accessibility}
            </p>
          )}
        </div>

        <hr className="border-t border-[#DDDDDD] w-full " />
        <div className="flex gap-[21px] items-center flex-wrap">
          <button
            onClick={handleSubmit}
            disabled={isAdding || isUpdating}
            className="md:w-auto w-full rounded-[2px] bg-[#4CAF50] text-[17px] text-white text-center font-bold py-[10px] px-[24px] green-shadow hover:bg-[#209b25] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {(isAdding || isUpdating) && (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            )}
            {t("addNewRoom").buttons.saveChanges}
          </button>
          <button
            onClick={handleCancel}
            disabled={isAdding || isUpdating}
            className="md:w-auto w-full rounded-[2px] bg-white text-[17px] border border-[#DDDDDD] text-center font-semibold py-[11px] px-[24px] text-black hover:bg-[#F2F2F2] disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {t("addNewRoom").buttons.cancel}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddNewRoom;
